import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
const META_PIXEL_ID = '1636316570804025';
type MetaPixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push: (...args: unknown[]) => void;
  loaded: boolean;
  version: string;
};
type MetaWindow = Window & {
  fbq?: MetaPixelFunction;
  _fbq?: MetaPixelFunction;
  __metaPixelReady?: boolean;
};
function createPixelStub(metaWindow: MetaWindow): MetaPixelFunction {
  const pixel = function (...args: unknown[]) {
    if (pixel.callMethod) {
      pixel.callMethod(...args);
      return;
    }
    pixel.queue.push(args);
  } as MetaPixelFunction;
  pixel.queue = [];
  pixel.push = (...args: unknown[]) => pixel.queue.push(args);
  pixel.loaded = true;
  pixel.version = '2.0';
  metaWindow.fbq = pixel;
  metaWindow._fbq = pixel;
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  script.dataset.metaPixel = 'true';
  document.head.appendChild(script);
  return pixel;
}

// Initializes the pixel and sends PageView EXACTLY ONCE per page load, so remounts,
// React strict-mode double effects, or a second snippet can never duplicate events.
function loadMetaPixel() {
  const metaWindow = window as MetaWindow;
  if (metaWindow.__metaPixelReady) return;
  metaWindow.__metaPixelReady = true;
  const pixel = metaWindow.fbq ?? createPixelStub(metaWindow);
  pixel('init', META_PIXEL_ID);
  pixel('track', 'PageView');
}
export function App() {
  useEffect(() => {
    loadMetaPixel();
  }, []);
  return <>
      <LandingPage data-id="element-0" data-mp="38kqgafp2ys2l" />
      <noscript data-id="element-1" data-mp="38kgkucl9nspi">
        <img src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} height="1" width="1" alt="" style={{
        display: 'none'
      }} data-id="element-2" data-mp="38o4gbha9up6v" />
      </noscript>
    </>;
}